import { ItemData } from "sharedGuiSmall/components";

export const currencyUtcSymbols: Array<ItemData> = [
    { id: 0, value: 'GBP', disabled: false },
    { id: 1, value: 'USD', disabled: false },
    { id: 2, value: 'EUR', disabled: false },
    { id: 3, value: 'CAD', disabled: false },
    { id: 4, value: 'AUD', disabled: false }];

export const currencySymbols: Array<ItemData> = [
    { id: 0, value: '£', disabled: false },
    { id: 1, value: '$', disabled: false },
    { id: 2, value: '€', disabled: false },
    { id: 3, value: '$', disabled: false },
    { id: 4, value: '$', disabled: false }];

